import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('list'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

import infiniteScroll from 'vue-infinite-scroll';
import MaiRow from '../row';
import MaiLoading from '../loading';
export default {
    directives: {
        infiniteScroll: infiniteScroll
    },
    components: {
        MaiRow: MaiRow,
        MaiLoading: MaiLoading
    },
    name: getComponentName('List'),
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errored: {
            type: Boolean,
            default: false
        },
        distance: {
            type: Number,
            default: 200
        },
        immediateCheck: {
            type: Boolean,
            default: true
        },
        throttleDelay: {
            type: Number,
            default: 200
        }
    },
    methods: {
        loadMore: function loadMore() {
            if (!this.loading && !this.disabled) {
                this.$emit('load');
            }
        }
    },
    computed: {
        status: function status() {
            if (this.errored) {
                return 'errored';
            } else if (this.disabled) {
                return 'finished';
            } else if (this.loading) {
                return 'loading';
            } else {
                return 'pending';
            }
        }
    },
    render: function render() {
        var h = arguments[0];
        var loadMore = this.loadMore;
        return h(
            'div',
            {
                class: b()
            },
            [
                this.$slots.default,
                h(
                    'div',
                    {
                        attrs: {
                            'infinite-scroll-disabled': 'disabled',
                            'infinite-scroll-distance': 'distance',
                            'infinite-scroll-immediate-check': 'immediateCheck',
                            'infinite-scroll-throttle-delay': 'throttleDelay'
                        },
                        directives: [
                            {
                                name: 'infinite-scroll',
                                value: loadMore
                            }
                        ]
                    },
                    [
                        this.status === 'errored'
                            ? this.$slots.errored
                                ? this.$slots.errored
                                : h(
                                      'mai-row',
                                      {
                                          attrs: {
                                              align: 'center',
                                              justify: 'center'
                                          },
                                          class: 'mai-list__finished',
                                          slot: 'finished'
                                      },
                                      [h('div', ['\u52A0\u8F7D\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u518D\u8BD5'])]
                                  )
                            : '',
                        this.status === 'finished'
                            ? this.$slots.finished
                                ? this.$slots.finished
                                : h(
                                      'mai-row',
                                      {
                                          attrs: {
                                              align: 'center',
                                              justify: 'center'
                                          },
                                          class: 'mai-list__finished',
                                          slot: 'finished'
                                      },
                                      [h('div', ['\u6CA1\u6709\u66F4\u591A\u4E86'])]
                                  )
                            : '',
                        this.status === 'loading'
                            ? this.$slots.loading
                                ? this.$slots.loading
                                : h(
                                      'mai-row',
                                      {
                                          attrs: {
                                              align: 'center',
                                              justify: 'center'
                                          },
                                          class: 'mai-list__loading',
                                          slot: 'loading'
                                      },
                                      [
                                          h(
                                              'mai-loading',
                                              {
                                                  attrs: {
                                                      size: '30',
                                                      'text-color': '#c4c2c0',
                                                      'text-size': '24'
                                                  }
                                              },
                                              ['\u52A0\u8F7D\u4E2D...']
                                          )
                                      ]
                                  )
                            : '',
                        this.status === 'pending'
                            ? this.$slots.pending
                                ? this.$slots.pending
                                : h(
                                      'mai-row',
                                      {
                                          attrs: {
                                              align: 'center',
                                              justify: 'center'
                                          },
                                          class: 'mai-list__pending',
                                          slot: 'pending'
                                      },
                                      [h('div', ['\u4E0A\u62C9\u52A0\u8F7D'])]
                                  )
                            : ''
                    ]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
